import React from 'react';
import { connect } from 'react-redux';
import { Card, Table, TableBody, TableCell, TableRow, withTheme } from '@material-ui/core';

import { AscendState } from '../../ducks';
import { formatFieldValue } from '../shared/format';
import { getExpenses, getIncome } from '../../ducks/mx';

import { dummyTransactions } from '../dummyData/dummyTransactions';

type StateProps = {
  monthlyIncome: number;
  monthlyExpenses: number;
};
type CashFlowTableProps = StateProps;

const getColor = (value: number) => {
  if (value < 0) return 'red';
  if (value > 0) return 'green';
  return 'black';
};

const CashFlowTable = ({ monthlyIncome, monthlyExpenses }: CashFlowTableProps) => {
  const disposableIncome = monthlyIncome - monthlyExpenses;

  return (
    <Card elevation={2}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2} style={{ fontWeight: 600 }}>
              Cash Flow
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Monthly Income</TableCell>
            <TableCell style={{ color: getColor(monthlyIncome), textAlign: 'right' }}>
              {formatFieldValue(monthlyIncome, 'number', 'dollar')}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Monthly Expenses</TableCell>
            <TableCell style={{ color: getColor(-monthlyExpenses), textAlign: 'right' }}>
              {formatFieldValue(monthlyExpenses, 'number', 'dollar')}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Disposable Income</TableCell>
            <TableCell style={{ color: getColor(disposableIncome), textAlign: 'right' }}>
              {formatFieldValue(disposableIncome, 'number', 'dollar')}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};

//todo I think I can use mx.ts file to do the following differently will come back to this later as I need to move on to the next pieces and this works
const mapStateToProps = (state: AscendState) => {
  const showDummyData = state.user.data.showDummyData;
  if (showDummyData) {
    // Calculate dummy income: sum of all CREDIT amounts
    const dummyIncome = dummyTransactions
      .filter((tx) => tx.type === 'CREDIT')
      .reduce((sum, tx) => sum + tx.amount, 0);
    // Calculate dummy expenses: sum of all DEBIT amounts
    const dummyExpenses = dummyTransactions
      .filter((tx) => tx.type === 'DEBIT')
      .reduce((sum, tx) => sum + tx.amount, 0);
    return {
      monthlyIncome: dummyIncome,
      monthlyExpenses: dummyExpenses,
    };
  } else {
    return {
      monthlyIncome: getIncome(state),
      monthlyExpenses: getExpenses(state),
    };
  }
};

export default withTheme()(connect<StateProps>(mapStateToProps)(CashFlowTable));